import Vue from "vue";
import Vuex from "vuex";
import user from './modules/user';
import createPersistedState from 'vuex-persistedstate';
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
  },
  plugins: [
    createPersistedState({
      reducer: state => ({
        user: state.user,
      }),
    }),
  ],

});
